export enum TaxRole {
    Owner = 'OWNER',
    Other = 'OTHER',
}
